import React from "react";
import Select from "react-select";
import { DropdownButton, MenuItem, OverlayTrigger, Popover } from "react-bootstrap";
import moment from "moment";

import { Button } from "aible";

import HomeIcon from "images/EDG/HomeIcon.svg";
import SettingsIcon from "images/EDG/SettingsIcon.svg";
import NumberIcon from "images/EDG/NumberIcon.svg";
import CategoryIcon from "images/EDG/CategoryIcon.svg";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faTrash } from "@fortawesome/free-solid-svg-icons";

import { LineInput } from "components/Inputs/LineInput";

import { VIEW_TYPE } from "containers/View/reducer";

import styles from "./style.module.css";

export default class Blueprint extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isAddField: false,
      addField: {}
    };
  }

  renderHeader() {
    const { blueprint, updateType, isBlueprintCreating, saveBlueprint, history, canEdit } = this.props;

    return (
      <div className={styles.gHeader}>
        <div
          className={styles.homeIcon}
          onClick={() => {
            updateType(VIEW_TYPE.BLUEPRINTS);
            history.push("/");
          }}
        >
          <Button style={{ paddingLeft: "7px", paddingRight: "7px" }}>
            <img src={HomeIcon} />
          </Button>
        </div>
        <div className={styles.datasetHeader}>
          <div>
            <div className={styles.boldItem}>
              <div style={{ width: "350px", marginLeft: "-7px" }}>
                <LineInput
                  isCleanEditable
                  isMediumBox
                  defaultValue={blueprint && blueprint.name ? blueprint.name : "New Blueprint"}
                  isLocked={!canEdit}
                  ref={"bpName"}
                />
              </div>
            </div>
            <div className={styles.subItem}>
              {blueprint ? moment.utc(blueprint.created).local().format("MMMM Do YYYY, h:mm:ss a") : ""}
            </div>
          </div>
        </div>
        <div className={styles.actionButtons}>
          {isBlueprintCreating ? (
            <LoadingIndicator />
          ) : (
            <OverlayTrigger
              placement="top"
              trigger={canEdit ? [] : ["hover"]}
              rootClose
              overlay={
                <Popover id="popover-positioned-top">
                  <div className={styles.tileOverlay}>
                    {"You need edit permission in the folder in order to save this blueprint"}
                  </div>
                </Popover>
              }
            >
              <Button
                type="primary"
                disabled={!canEdit}
                onClick={() => {
                  const bpName =
                    this.refs["bpName"] && this.refs["bpName"].state
                      ? this.refs["bpName"].state.tempVal
                      : "New Blueprint";
                  saveBlueprint(bpName);
                }}
              >
                {"Save Blueprint"}
              </Button>
            </OverlayTrigger>
          )}
        </div>
      </div>
    );
  }

  renderField(field, index, isAdd) {
    const { updateDataField } = this.props;

    return (
      <div className={styles.descInput}>
        <div className={styles.fFlex}>
          {field.type === "categorical" ? (
            <img src={CategoryIcon} style={{ marginRight: "5px" }} title={"Categorical"} />
          ) : (
            <img src={NumberIcon} style={{ marginRight: "5px", marginLeft: "-2px" }} title={"Numeric"} />
          )}
          {isAdd ? (
            <LineInput
              isMediumBox
              isCleanEditable
              style={{
                height: "50px",
                justifyContent: "flex-start",
                width: "100%"
              }}
              placeholder="Add Description"
              defaultValue={field.label}
              onChange={(value) =>
                isAdd
                  ? this.setState({
                      addField: { ...this.state.addField, label: value }
                    })
                  : updateDataField({ ...field, label: value })
              }
            />
          ) : (
            <div className={styles.fFlexLabel} title={field.label}>
              {field.label}
            </div>
          )}
        </div>
      </div>
    );
  }

  renderIsActionable(field, index, isAdd) {
    const { updateDataField, canManagePermissions } = this.props;

    return (
      <div
        className={styles.checkboxHolder + " " + (canManagePermissions ? "" : styles.noClick)}
        onClick={
          canManagePermissions
            ? () =>
                isAdd
                  ? this.setState({
                      addField: {
                        ...this.state.addField,
                        isActionable: !field.isActionable
                      }
                    })
                  : updateDataField({
                      ...field,
                      isActionable: !field.isActionable
                    })
            : undefined
        }
      >
        <input type="checkbox" checked={field.isActionable === true ? true : false} onChange={() => {}} />
      </div>
    );
  }

  renderIsSensitive(field, index, isAdd) {
    const { updateDataField, canManagePermissions } = this.props;

    return (
      <div
        className={styles.checkboxHolder + " " + (canManagePermissions ? "" : styles.noClick)}
        onClick={
          canManagePermissions
            ? () =>
                isAdd
                  ? this.setState({
                      addField: {
                        ...this.state.addField,
                        isSensitive: !field.isSensitive
                      }
                    })
                  : updateDataField({
                      ...field,
                      isSensitive: !field.isSensitive,
                      isIgnoreAnalysis: !field.isSensitive ? true : field.isIgnoreAnalysis
                    })
            : undefined
        }
      >
        <input type="checkbox" checked={field.isSensitive === true ? true : false} onChange={() => {}} />
      </div>
    );
  }

  renderAllowAnalysis(field, index, isAdd) {
    const { updateDataField, canManagePermissions } = this.props;

    return (
      <div
        className={styles.checkboxHolder + " " + (canManagePermissions ? "" : styles.noClick)}
        onClick={
          canManagePermissions
            ? () =>
                isAdd
                  ? this.setState({
                      addField: {
                        ...this.state.addField,
                        isIgnoreAnalysis: false
                      }
                    })
                  : updateDataField({
                      ...field,
                      isIgnoreAnalysis: !field.isIgnoreAnalysis
                    })
            : undefined
        }
      >
        <input type="checkbox" checked={field.isIgnoreAnalysis === true ? false : true} onChange={() => {}} />
      </div>
    );
  }

  renderDescription(field, index, isAdd) {
    const { updateDataField, canEdit } = this.props;

    return (
      <div className={styles.descInput}>
        <LineInput
          isMediumBox
          isCleanEditable
          style={{
            height: "50px",
            justifyContent: "flex-start",
            width: "100%"
          }}
          isLocked={!canEdit}
          placeholder={canEdit ? "Add Description" : ""}
          defaultValue={field.desc}
          onChange={(value) =>
            isAdd
              ? this.setState({
                  addField: {
                    ...this.state.addField,
                    desc: value
                  }
                })
              : updateDataField({ ...field, desc: value })
          }
        />
      </div>
    );
  }

  renderMatches(field, index, isAdd) {
    const { blueprint, datasets, history, updateHighlightField } = this.props;

    const matches =
      blueprint && blueprint.wizard && blueprint.wizard.linkedDatasets
        ? Object.keys(blueprint.wizard.linkedDatasets).map((d) => ({
            datasetId: d,
            dataset:
              datasets && datasets.filter((ds) => ds.id === Number(d)).length > 0
                ? datasets.filter((ds) => ds.id === Number(d))[0]
                : undefined,
            fields: blueprint.wizard.linkedDatasets[d]
          }))
        : [];

    return isAdd ? (
      <div />
    ) : (
      <div
        style={
          matches && matches.length > 2
            ? {
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                paddingTop: "5px",
                height: "100%",
                width: "100%"
              }
            : {}
        }
      >
        {matches.map((m) =>
          Object.keys(m.fields)
            .filter((f) => m.fields[f] === field.label)
            .map((f, i) => (
              <OverlayTrigger
                key={i}
                placement={"top"}
                trigger={["click"]}
                rootClose
                overlay={
                  <Popover id={"popover-positioned-top"} title={"Dataset Details"}>
                    <div className={styles.datasetTooltip}>
                      {m.dataset ? (
                        <React.Fragment>
                          <div className={styles.tFlex}>
                            <div>{"Dataset"}</div>
                            <div>{m.dataset ? m.dataset.label : ""}</div>
                          </div>
                          <div className={styles.tFlex}>
                            <div>{"Matched By"}</div>
                            <div>{m.dataset && m.dataset.created_by ? m.dataset.created_by.fullname : ""}</div>
                          </div>
                          <div className={styles.tFlex}>
                            <div>{"Date"}</div>
                            <div>{m.dataset ? moment.utc(m.dataset.created).local().format("MMMM Do YYYY") : ""}</div>
                          </div>
                        </React.Fragment>
                      ) : (
                        <div className={styles.tFlex}>
                          <div>{"Dataset Not Loaded"}</div>
                        </div>
                      )}
                      <Button
                        style={{ padding: "5px", marginTop: "20px" }}
                        onClick={() => {
                          history.push("/gallery/" + m.datasetId);
                          //updateHighlightField(m.datasetId, f);
                        }}
                      >
                        {"View Dataset"}
                      </Button>
                    </div>
                  </Popover>
                }
              >
                <div>
                  <a
                    style={{
                      display: "flex",
                      alignItems: "center"
                    }}
                  >
                    <span
                      style={{
                        width: "175px",
                        textAlign: "right",
                        display: "inline-block",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "noWrap"
                      }}
                      title={m.dataset && m.dataset.label}
                    >
                      {(m.dataset && m.dataset.label ? m.dataset.label : "Dataset Not Loaded") + ": "}
                    </span>
                    <span style={{ marginLeft: "5px" }}>{f}</span>
                  </a>
                </div>
              </OverlayTrigger>
            ))
        )}
      </div>
    );
  }

  renderTable() {
    const { blueprint, blueprintFields, updateDataField, canEdit } = this.props;
    const { isAddField, addField } = this.state;

    const smallStyle = {
      minWidth: "140px",
      maxWidth: "140px"
    };

    const tableColumns = [
      {
        label: "Name",
        style: { flexGrow: 0.2 },
        render: (field, index, isAdd) => this.renderField(field, index, isAdd)
      },
      {
        label: "Sensitive",
        style: smallStyle,
        render: (field, index, isAdd) => this.renderIsSensitive(field, index, isAdd)
      },
      {
        label: "Allow Exploration",
        style: {
          minWidth: "160px",
          maxWidth: "160px"
        },
        render: (field, index, isAdd) => this.renderAllowAnalysis(field, index, isAdd)
      },
      // Temp Removal (Bring back for Aible Advanced)
      // {
      //   label: "Actionable",
      //   style: smallStyle,
      //   render: (field, index, isAdd) =>
      //     this.renderIsActionable(field, index, isAdd),
      // },
      {
        label: "Description",
        style: { flexGrow: 0.8 },
        render: (field, index, isAdd) => this.renderDescription(field, index, isAdd)
      },
      {
        label: "Matched Fields",
        style: {
          minWidth: "350px",
          maxWidth: "350px",
          paddingLeft: "20px",
          overflow: "auto"
        },
        render: (field, index, isAdd) => this.renderMatches(field, index, isAdd)
      },
      {
        label: " ",
        style: { minWidth: "120px", maxWidth: "120px", paddingLeft: "20px" },
        render: (field, index, isAdd) => (
          <div>
            <Button onClick={() => updateDataField({ ...field, isDeleted: true })}>
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </div>
        ),
        hide: !canEdit
      }
    ].filter((elem) => !elem.hide);

    return (
      <div className={styles.gTable}>
        <div className={styles.gTableHeader}>
          {tableColumns.map((c, i) => (
            <div className={styles.gTableCol} style={{ ...c.style, paddingLeft: "20px" }} key={i}>
              {c.label}
            </div>
          ))}
        </div>
        <div className={styles.gTableBody}>
          {blueprintFields ? (
            Object.keys(blueprintFields)
              .filter((f) => blueprintFields[f].isDeleted !== true)
              .map((f, i) => (
                <div className={styles.gTableRow} key={i}>
                  {tableColumns.map((c, j) => (
                    <div className={styles.gTableCol} style={c.style} key={j}>
                      {c.render(blueprintFields[f], i)}
                    </div>
                  ))}
                </div>
              ))
          ) : (
            <div />
          )}
          {isAddField ? (
            <div className={styles.gTableRow}>
              {tableColumns.map((c, j) => (
                <div className={styles.gTableCol} style={c.style} key={j}>
                  {c.render(addField, j, true)}
                </div>
              ))}
              <div className={styles.addActions}>
                <Button onClick={() => this.setState({ isAddField: false, addField: {} })}>{"Cancel"}</Button>
                <Button
                  onClick={() => {
                    updateDataField({ ...this.state.addField });
                    this.setState({ isAddField: false, addField: {} });
                  }}
                >
                  {"Save"}
                </Button>
              </div>
            </div>
          ) : (
            <div className={styles.gTableRow} style={{ justifyContent: "center" }}>
              <Button onClick={() => this.setState({ isAddField: true })}>{"Add New Field"}</Button>
            </div>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { blueprint, id } = this.props;

    if (blueprint === undefined && id !== "new") {
      return <div />;
    }

    return (
      <div className={styles.blueprint}>
        {this.renderHeader()}
        {this.renderTable()}
      </div>
    );
  }
}
